var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"title_name"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"sub_title"},[_vm._v(_vm._s(_vm.desc))])]),_vm._v(" "),_c('div',{staticClass:"slot_wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce5c962","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/container.vue
// module id = null
// module chunks = 